import React, { useEffect, useState } from 'react';
import { ChevronUp } from 'lucide-react';
export function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = docHeight > 0 ? scrollTop / docHeight * 100 : 0;
      setScrollProgress(progress);
      setVisible(scrollTop > 400);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  // SVG circle progress
  const size = 44;
  const strokeWidth = 2.5;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - scrollProgress / 100 * circumference;
  return <button onClick={scrollToTop} aria-label="Kembali ke atas" className={`
        fixed bottom-6 right-6 z-50 group
        transition-all duration-500 ease-out
        ${visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'}
      `} data-id="element-298">
      {/* Outer ring with progress */}
      <div className="relative w-11 h-11 flex items-center justify-center" data-id="element-299">
        {/* Progress SVG */}
        <svg width={size} height={size} className="absolute inset-0 -rotate-90" data-id="element-300">
          {/* Track */}
          <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="rgba(26,71,49,0.15)" strokeWidth={strokeWidth} data-id="element-301" />
          {/* Progress */}
          <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#1A4731" strokeWidth={strokeWidth} strokeLinecap="round" strokeDasharray={circumference} strokeDashoffset={strokeDashoffset} className="transition-all duration-150" data-id="element-302" />
        </svg>

        {/* Button core */}
        <div className="
            relative z-10 w-8 h-8 rounded-full
            bg-brand-green text-white
            flex items-center justify-center
            shadow-lg shadow-forest-900/20
            group-hover:bg-forest-600
            group-hover:shadow-xl group-hover:shadow-forest-900/30
            group-hover:-translate-y-0.5
            transition-all duration-200
          " data-id="element-303">
          <ChevronUp className="w-4 h-4 stroke-[2.5]" data-id="element-304" />
        </div>
      </div>
    </button>;
}